import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative overflow-hidden" style={{ width: "100%", height: "280px" }}>
        <img
          src={movie.posterUrl}
          alt={movie.title}
          title={`${movie.title} - 光棍影院免费高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {movie.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-accent-500 text-white whitespace-nowrap">
              NEW
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-primary-500 text-white whitespace-nowrap">
              热播
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-bold rounded-md bg-black/50 text-yellow-400 whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-bold text-white truncate">{movie.title}</h3>
          <p className="text-xs text-white/70 mt-1 truncate">{movie.category} · {movie.year}</p>
        </div>
      </div>
    </Link>
  );
}